import { render, staticRenderFns } from "./EditPhone.vue?vue&type=template&id=90422afa&scoped=true&"
import script from "./EditPhone.vue?vue&type=script&lang=js&"
export * from "./EditPhone.vue?vue&type=script&lang=js&"
import style0 from "./EditPhone.vue?vue&type=style&index=0&id=90422afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90422afa",
  null
  
)

export default component.exports